import { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";

// Framer Motion via CDN import simulation — using CSS animations + inline styles
// Since framer-motion may not be available, we'll use CSS transitions with React state

const testimonials = [
  {
    id: 1,
    text: "Tutor Network-এর মাধ্যমে খুব সহজে পছন্দের টিউটর পেয়েছি। ওয়েবসাইট ব্যবহার করা সহজ এবং সাপোর্ট টিমও বেশ Supportive",
    name: "Ishrat Amin",
    role: "Part-time tutor",
    institution: "North South University (NSU)",
    rating: 5,
    avatar: "https://goatteachers.com/assets/testimonial_1.webp",
    tag: "Tutor & Student",
  },
  {
    id: 2,
    text: "Honestly, Tutor Network use kore amar experience ta onek smooth chilo. Ami amar chhoto bhai er jonno ekta good home tutor khujchilam, and within 2 days e perfect match peye gelam.",
    name: "Fahiya Faiza",
    // role: "Student",
    institution: "Guardian",
    rating: 4,
    avatar: "https://goatteachers.com/assets/testimonial_2.webp",
    tag: "Student",
  },
  {
    id: 3,
    text: "আমার জন্য সেরা অভিজ্ঞতা ছিল — Verified Tutor Badge দেখে Decision নেয়া যে কোন টিচারটাকে Select করবো। দারুণ উদ্যোগ!",
    name: "Rudra Saha",
    role: "HSC Candidate",
    institution: "Dhaka College",
    rating: 5,
    avatar: "https://goatteachers.com/assets/testimonial_3.webp",
    tag: "HSC Student",
  },
];

const StarRating = ({ count }) => (
  <div style={{ display: "flex", gap: "3px" }}>
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        size={14}
        fill={i < count ? "#25d976" : "transparent"}
        stroke={i < count ? "#25d976" : "#444"}
        strokeWidth={1.5}
      />
    ))}
  </div>
);

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);
  const [animating, setAnimating] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const goTo = (index, dir) => {
    if (animating) return;
    setAnimating(true);
    setDirection(dir);
    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 350);
  };

  const prev = () => {
    const idx = current === 0 ? testimonials.length - 1 : current - 1;
    goTo(idx, -1);
  };

  const next = () => {
    const idx = current === testimonials.length - 1 ? 0 : current + 1;
    goTo(idx, 1);
  };

  useEffect(() => {
    if (isPaused) return;
    const id = setInterval(next, 5500);
    return () => clearInterval(id);
  }, [isPaused, current]);

  const onTouchStart = (e) => (touchStartX.current = e.touches[0].clientX);
  const onTouchMove = (e) => (touchEndX.current = e.touches[0].clientX);
  const onTouchEnd = () => {
    const delta = touchStartX.current - touchEndX.current;
    if (delta > 50) next();
    if (delta < -50) prev();
  };

  const t = testimonials[current];

  return (
    <section
      style={{
        background:
          "linear-gradient(135deg, #000000 0%, #0a0f1e 50%, #000d08 100%)",
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4rem 1.5rem",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'DM Sans', sans-serif",
      }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {/* Google Font */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,300&family=Syne:wght@700;800&display=swap');

        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(18px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulseGlow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37,217,118,0.15); }
          50% { box-shadow: 0 0 40px 10px rgba(37,217,118,0.08); }
        }
        @keyframes floatBlob {
          0%, 100% { transform: translate(0,0) scale(1); }
          50% { transform: translate(-20px, 15px) scale(1.05); }
        }
        @keyframes floatBlob2 {
          0%, 100% { transform: translate(0,0) scale(1); }
          50% { transform: translate(15px, -20px) scale(1.04); }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        .card-anim {
          animation: fadeSlideIn 0.45s cubic-bezier(0.22,1,0.36,1) both;
        }
        .nav-btn:hover {
          background: rgba(37,217,118,0.15) !important;
          border-color: #25d976 !important;
          color: #25d976 !important;
          transform: scale(1.05);
        }
        .nav-btn:active { transform: scale(0.96); }
        .dot-btn:hover { background: rgba(37,217,118,0.6) !important; transform: scale(1.3); }
        .tag-badge {
          background: linear-gradient(90deg, rgba(37,217,118,0.15), rgba(37,217,118,0.05));
          border: 1px solid rgba(37,217,118,0.3);
          color: #25d976;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 3px 10px;
          border-radius: 999px;
        }
        .avatar-ring {
          animation: pulseGlow 3s ease-in-out infinite;
        }
        .shimmer-text {
  font-family: 'Hind Siliguri', sans-serif;
  background: linear-gradient(90deg, #fff 40%, #25d976 50%, #fff 60%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 4s linear infinite;
}
        .number-badge {
          font-family: 'Syne', sans-serif;
          font-weight: 600;
          font-size: 8px;
          letter-spacing: 0.08em;
          color: #555;
        }
      `}</style>

      {/* Background blobs */}
      <div
        style={{
          position: "absolute",
          top: "-10%",
          right: "-5%",
          width: "420px",
          height: "420px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(37,217,118,0.06) 0%, transparent 70%)",
          animation: "floatBlob 9s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "5%",
          left: "-8%",
          width: "350px",
          height: "350px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(30,60,200,0.07) 0%, transparent 70%)",
          animation: "floatBlob2 11s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />

      {/* Subtle grid texture */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          backgroundImage: `
          linear-gradient(rgba(37,217,118,0.02) 1px, transparent 1px),
          linear-gradient(90deg, rgba(37,217,118,0.02) 1px, transparent 1px)
        `,
          backgroundSize: "60px 60px",
        }}
      />

      {/* Main wrapper */}
      <div style={{ width: "100%", maxWidth: "860px", position: "relative" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "3.5rem" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "1rem",
            }}
          >
            <div
              style={{
                height: "1px",
                width: "32px",
                background: "linear-gradient(90deg, transparent, #25d976)",
              }}
            />
            <span
              style={{
                fontSize: "11px",
                fontWeight: 600,
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "#25d976",
              }}
            >
              What they say
            </span>
            <div
              style={{
                height: "1px",
                width: "32px",
                background: "linear-gradient(90deg, #25d976, transparent)",
              }}
            />
          </div>
          <h2
            style={{
              fontFamily: "'Hind Siliguri', sans-serif",
              fontSize: "clamp(2rem, 5vw, 3rem)",
              fontWeight: 700,
              color: "#fff",
              margin: 0,
              lineHeight: 1.2,
              paddingTop: "0.08em",
            }}
          >
            <span className="shimmer-text">ফিডব্যাক</span>
          </h2>
        </div>

        {/* Card */}
        <div
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          style={{ position: "relative" }}
        >
          <div
            key={current}
            className="card-anim"
            style={{
              background:
                "linear-gradient(145deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.01) 100%)",
              border: "1px solid rgba(255,255,255,0.07)",
              borderRadius: "24px",
              padding: "clamp(2rem, 5vw, 3.5rem)",
              backdropFilter: "blur(20px)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Card accent line */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "10%",
                right: "10%",
                height: "1px",
                background:
                  "linear-gradient(90deg, transparent, rgba(37,217,118,0.4), transparent)",
              }}
            />

            {/* Large decorative quote */}
            <div
              style={{
                position: "absolute",
                top: "1.5rem",
                right: "2rem",
                opacity: 0.04,
                pointerEvents: "none",
              }}
            >
              <Quote size={120} strokeWidth={1} color="#25d976" />
            </div>

            {/* Top row: tag + rating */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: "2rem",
                flexWrap: "wrap",
                gap: "0.75rem",
              }}
            >
              <span className="tag-badge">{t.tag}</span>
              <StarRating count={t.rating} />
            </div>

            {/* Quote text */}
            <blockquote
              style={{
                margin: "0 0 2.5rem 0",
                padding: 0,
                fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
                fontWeight: 300,
                lineHeight: 1.75,
                color: "rgba(255,255,255,0.82)",
                fontStyle: "italic",
                letterSpacing: "0.01em",
              }}
            >
              &ldquo;{t.text}&rdquo;
            </blockquote>

            {/* Divider */}
            <div
              style={{
                height: "1px",
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent)",
                marginBottom: "2rem",
              }}
            />

            {/* Author */}
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <div
                className="avatar-ring"
                style={{
                  borderRadius: "50%",
                  padding: "2px",
                  background: "linear-gradient(135deg, #25d976, #1a9c55)",
                  flexShrink: 0,
                }}
              >
                <img
                  src={t.avatar}
                  alt={t.name}
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "50%",
                    display: "block",
                    border: "2px solid #000",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(t.name)}&background=25d976&color=000&size=52`;
                  }}
                />
              </div>
              <div>
                <p
                  style={{
                    margin: 0,
                    fontFamily: "'Syne', sans-serif",
                    fontWeight: 700,
                    fontSize: "1rem",
                    color: "#fff",
                    letterSpacing: "0.01em",
                  }}
                >
                  {t.name}
                </p>
                <p
                  style={{
                    margin: "3px 0 0 0",
                    fontSize: "0.78rem",
                    color: "rgba(255,255,255,0.4)",
                    fontWeight: 400,
                  }}
                >
                  {t.role} &bull; {t.institution}
                </p>
              </div>

              {/* Slide counter */}
              <div style={{ marginLeft: "auto" }}>
                <span className="number-badge">
                  {String(current + 1).padStart(2, "0")} /{" "}
                  {String(testimonials.length).padStart(2, "0")}
                </span>
              </div>
            </div>
          </div>

          {/* Nav Buttons */}
          <button
            className="nav-btn"
            onClick={prev}
            aria-label="Previous"
            style={{
              position: "absolute",
              left: "-20px",
              top: "50%",
              transform: "translateY(-50%)",
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,0.1)",
              background: "rgba(0,0,0,0.6)",
              color: "rgba(255,255,255,0.6)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
              backdropFilter: "blur(10px)",
              zIndex: 10,
            }}
          >
            <ChevronLeft size={18} />
          </button>

          <button
            className="nav-btn"
            onClick={next}
            aria-label="Next"
            style={{
              position: "absolute",
              right: "-20px",
              top: "50%",
              transform: "translateY(-50%)",
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,0.1)",
              background: "rgba(0,0,0,0.6)",
              color: "rgba(255,255,255,0.6)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
              backdropFilter: "blur(10px)",
              zIndex: 10,
            }}
          >
            <ChevronRight size={18} />
          </button>
        </div>

        {/* Dots */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            marginTop: "2.5rem",
          }}
        >
          {testimonials.map((_, i) => (
            <button
              key={i}
              className="dot-btn"
              onClick={() => goTo(i, i > current ? 1 : -1)}
              aria-label={`Go to slide ${i + 1}`}
              style={{
                width: i === current ? "28px" : "8px",
                height: "8px",
                borderRadius: "999px",
                border: "none",
                background:
                  i === current ? "#25d976" : "rgba(255,255,255,0.15)",
                cursor: "pointer",
                transition: "all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
                padding: 0,
              }}
            />
          ))}
        </div>

        {/* Thumbnail strip */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginTop: "2rem",
          }}
        >
          {testimonials.map((item, i) => (
            <button
              key={i}
              onClick={() => goTo(i, i > current ? 1 : -1)}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                transition: "all 0.2s ease",
                opacity: i === current ? 1 : 0.35,
                transform: i === current ? "scale(1.1)" : "scale(1)",
              }}
            >
              <img
                src={item.avatar}
                alt={item.name}
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  border:
                    i === current
                      ? "2px solid #25d976"
                      : "2px solid transparent",
                  objectFit: "cover",
                  display: "block",
                  transition: "border 0.2s ease",
                }}
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(item.name)}&background=25d976&color=000&size=36`;
                }}
              />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
